// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".continue-button[data-v-4060b903]{text-align:center;margin:1rem 0}[data-v-4060b903] .text-payment-policy{width:fit-content !important}[data-v-4060b903] .text-payment-notice{width:auto !important;display:block !important}[data-v-4060b903] #card-element{width:auto;margin-bottom:0.5rem}\n", ""]);
// Exports
module.exports = exports;
